import { createSlice } from '@reduxjs/toolkit';

interface IState {
	externalClaimId: number;
	claimUUID: string;
	open: boolean;
}

const initialState: IState = {
	externalClaimId: 0,
	claimUUID: '',
	open: false,
};

export type SubmitClaimMappingPayload = {
	claimUUID: string;
	externalClaimId: string;
};

const SubmitClaimHookSlice = createSlice({
	name: 'hooks-submitClaim',
	initialState,
	reducers: {
		setDialogSubmitClaimOpen: (state, { payload }) => {
			state.open = payload;
		},
		setInjectionState: (state, { payload }) => {
			state.claimUUID = payload.claimUUID;
			state.externalClaimId = payload.externalClaimId;
		},
		resetDialogSubmitClaim: () => initialState,
	},
	extraReducers: builder => {},
});

export const {
	setDialogSubmitClaimOpen,
	setInjectionState,
	resetDialogSubmitClaim,
} = SubmitClaimHookSlice.actions;
export default SubmitClaimHookSlice.reducer;
